<template>
  <div class="support-container">
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6 col-lg-4">
          <div class="text-center mb-5">
            <img src="../../public/img/logosidebar.png" class="img-fluid logo-img" alt="Latydo Logo" />
          </div>
          <div class="d-grid gap-4 p-4">
            <a href="https://wa.me/584126644526" 
               class="btn custom-btn d-flex align-items-center justify-content-center gap-2">
              <i class="bi bi-whatsapp"></i>
              Ir al WhatsApp de soporte
            </a>

            <a href="https://latydo.com" 
               target="_blank"
               class="btn custom-btn d-flex align-items-center justify-content-center gap-2">
              <i class="bi bi-globe"></i>
              Accede a nuestra página web
            </a>

            <a href="mailto:info@latydo.com" 
               class="btn custom-btn d-flex align-items-center justify-content-center gap-2">
              <i class="bi bi-envelope"></i>
              Envíanos un correo electrónico
            </a>

            <a href="https://instagram.com/latydoapp" 
               target="_blank"
               class="btn custom-btn d-flex align-items-center justify-content-center gap-2">
              <i class="bi bi-instagram"></i>
              Síguenos en Instagram
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Support'
}
</script>

<style scoped>
.support-container {
  min-height: 100vh;
  background-color: #20C29D;
  display: flex;
  align-items: center;
}

.logo-img {
  max-width: 200px;
  margin: 0 auto;
}

.custom-btn {
  transition: all 0.3s ease;
  border-radius: 12px;
  font-weight: 600;
  padding: 20px;
  background-color: transparent;
  border: 2px solid white;
  color: white;
  font-size: 1.1rem;
}

.custom-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background-color: rgba(255, 255, 255, 0.1);
}

.bi {
  font-size: 1.4rem;
}
</style>